import Vue from 'vue'
import Router from 'vue-router'
import { loginPatientCenter, syncUsingOutData } from "@/api/loginApi.js";
import { getCurrentUserInfo } from "@/api/systemApi.js";
import { getMenuTreeListByRoleId } from '@/api/menuApi.js'
import { setPermission } from '@/common/utils/permission.js'
import SysSettingRoutes from './module/system_setting'
import { getWxUserByRelevance } from "@/api/business/questionnaireManage.js";
Vue.use(Router)

const defaultRoutes = [
  {
    path: '/login',
    component: (resolve) => require(['@/views/login/login'], resolve),
    hidden: true
  },
  {
    path: '/',
    component: (resolve) => require(['@/views/login/login'], resolve),
    hidden: true
  },
  {
    path: '/401',
    component: (resolve) => require(['@/views/error/401'], resolve),
    hidden: true
  },
  {
    path: '/404',
    component: (resolve) => require(['@/views/error/404'], resolve),
    hidden: true
  },
  {
    path: '/webAnswerPage/webAnswer',
    component: (resolve) => require(['@/views/public/web_answer_page'], resolve),
    hidden: true
  },
  {
    path: '*',
    component: (resolve) => require(['@/views/error/404'], resolve),
    hidden: true
  },
]

//解决ElementUI导航中的重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = new Set([...SysSettingRoutes, ...defaultRoutes])   //,...systemManagmentSetting
const router = new Router({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) { // 使用keepalive缓存不加这个第一次会无效
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

function surebingWechat(code) {    //绑定微信
  getWxUserByRelevance({
    code: code
  }).then(res => {
    if (res.data.code == 200) {
      getCurrentUserInfo().then((res => {
        if (res.data.code == 200 && res.data.success) {
          sessionStorage.setItem('userInfo', JSON.stringify(res.data.data))
          location.reload()
        }
      })).catch((e) => {

      })
      Vue.prototype.$notify({
        message: res.data.message,
        duration: 3000,
        background: '#22b3ad'
      })
      // Vue.$message.success('关联成功,下次可直接微信扫码登录')
    } else {
      // location.reload()
      Vue.prototype.$notify({
        message: res.data.message,
        duration: 5000,
        background: '#FF0000'
      })

    }

  })
}

//路由拦截  需要校验权限问题   后期直接从后台回去路由配置动态添加则无须校验
router.beforeEach(async (to, from, next) => {
  const token = new URLSearchParams(window.location.search).get('token')
  if (token) {
    sessionStorage.removeItem('permissionsList')
    sessionStorage.removeItem('userInfo')
    sessionStorage.removeItem('token')
    try {
      const data = await loginPatientCenter({ 'token': token })
      if (data.data.code === 200) {
        sessionStorage.setItem('token', data.data.data)
        // 获取用户信息
        try {
          const result = await Promise.all([getSyncUsingOutData(), getCurrentUser()])
          // 判断请求结果是否都成功
          const resultList = result.filter(res => res)
          if (resultList.length > 0) {
            window.sessionStorage.getItem('defaultActive') && window.sessionStorage.removeItem('defaultActive')
            window.open(window.location.origin + '/#/home/patients_report_management', '_self')
          } else {
            window.open(window.location.origin + '/#/login', '_self')
          }
        } catch (e) {
          console.error(e)
        }
      } else {
        Vue.prototype.$notify({
          message: data.data.message || '服务端异常，请联系技术支持',
          duration: 5000,
          background: '#FF0000',
          type: 'error'
        });
        next()
      }
    } catch (error) {
      Vue.prototype.$notify({
        message: error.data.message || '服务端异常，请联系技术支持',
        duration: 5000,
        background: '#FF0000',
        type: 'error'
      });
      next()
    }
  } else {
    next()
  }
  Vue.prototype.$testPermission = true
})

async function getSyncUsingOutData() {
  try {
    const res = await syncUsingOutData()
    if (res.data.code == 200 && res.data.success) {
      sessionStorage.setItem('syncUsingOutData', res.data.data)
      return true
    } else {
      sessionStorage.setItem('syncUsingOutData', true)
    }
  } catch (error) {
    sessionStorage.setItem('syncUsingOutData', true)
  }
  return false
}

async function getCurrentUser() {
  let roleIds = []
  try {
    const userInfo = await getCurrentUserInfo()
    if (userInfo.data.code === 200 && userInfo.data.success) {
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo.data.data))
      roleIds = userInfo.data.data.roleId.split(",")
    } else {
      sessionStorage.setItem('userInfo', '{}')
    }
  } catch (error) {
    console.error(error)
  }

  if (roleIds.length) {
    try {
      const list = []
      roleIds.forEach(element => {
        list.push(getMenuTreeListByRoleId({ roleId: element }))
      });
      const result = await Promise.all(list)
      const dataList = result.filter((res) => {
        return res != undefined
      })
      if (dataList.length > 0) {
        let permissionsList = setPermission(dataList)
        sessionStorage.setItem('permissionsList', permissionsList)
        return true
      } else {
        console.error('获取权限失败，请联系管理人员')
        sessionStorage.setItem('permissionsList', [])
      }
    } catch (error) {
      console.error(error)
      sessionStorage.setItem('permissionsList', [])
    }
  } else {
    console.error('当前用户没有赋予角色')
  }
  return false
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js